module.exports = __webpack_public_path__ + "static/media/md-save.f9c8c68b.svg";